import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RfqService } from '../../services/rfq/rfq.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs/internal/Subject';
import { TodayDateValidator } from 'src/app/modules/shared/services/custom-app-validators.service';

@Component({
  selector: 'app-edit-dead-line-dates-popup',
  templateUrl: './edit-dead-line-dates-popup.component.html',
  styleUrls: ['./edit-dead-line-dates-popup.component.scss']
})
export class EditDeadLineDatesPopupComponent implements OnInit {

  public prInitiatorForm !: FormGroup;
  public qt_deadline !: any;
  public deliveryDeadline !: any;
  public quotationDeadline !: any;
  public siemensDeadline !: any;
  public prId !:any;
  public onClose = new Subject<any>();
  public tempId!: any;

  constructor(public bsModalRef: BsModalRef,private rfqService: RfqService, private toasterService: ToastrService,private _fb: FormBuilder) { 
    
  }

  ngOnInit(): void {
    this.createForm();
    this.prInitiatorForm.controls["siemens_qt_deadline"].patchValue(this.qt_deadline);
    this.prInitiatorForm.controls["siemens_req_date_deli"].patchValue(this.deliveryDeadline);
    this.prInitiatorForm.get('siemens_qt_deadline')?.valueChanges.subscribe(value =>{
      this.prInitiatorForm.get('siemens_qt_deadline')?.setValidators(this.dateValidation());
      this.prInitiatorForm.updateValueAndValidity();
    });
    this.prInitiatorForm.get('siemens_req_date_deli')?.valueChanges.subscribe(value =>{
      this.prInitiatorForm.get('siemens_req_date_deli')?.setValidators(this.dateValidation());
      this.prInitiatorForm.updateValueAndValidity();
    })
  }

  createForm(){
    this.prInitiatorForm = this._fb.group({  
        siemens_qt_deadline: [, [Validators.required, TodayDateValidator()]],
        siemens_req_date_deli: [, [Validators.required, TodayDateValidator()]]
    })
    return this.prInitiatorForm;
  }

  
  updateDeadlines() {
    const payload =
    {
      prId: this.prId,
      siemens_qt_deadline: this.prInitiatorForm.get('siemens_qt_deadline')?.value,
      siemens_req_date_deli: this.prInitiatorForm.get('siemens_req_date_deli')?.value,
      templateId:this.tempId

    }
    this.rfqService.updateQuotationDeadlines(payload).subscribe((res: any) => {
      console.log(res);
      if (res.status === 200) {
        this.toasterService.success(res.message);
        this.onClose.next(true);
        this.bsModalRef.hide();
      }
    })
  }

  dateValidation(): ValidatorFn{
    const control1 = this.prInitiatorForm.get('siemens_qt_deadline');
    const control2 = this.prInitiatorForm.get('siemens_req_date_deli');
    return (control: AbstractControl): { [key: string]: any } | null =>{
      if (control1?.value && control2?.value && (new Date(control2.value) <= new Date(control1.value))){
        return {"LessThanDeadlineDate": true};
      }
      return null;
    }
  }
}
